<agpr-dialog-container
    id="importRecipientsDialog"
    heading="Common.mailingLists.importDialog.heading"
    [contentPadding]="false"
    (close)="cancel()"
>
    <div
        *ngIf="!hasFile"
        class="agpr-importRecipients-content"
        [agprLoading]="loading"
    >
        <input
            #fileInput
            type="file"
            class="agpr-importRecipients-upload"
            id="importRecipientsDialog.uploadInput"
            accept=".csv"
            (change)="handleFileInput($event.target.files[0])"
        />
        <div>
            {{ 'Common.mailingLists.importDialog.chooseCSV' | localize }}
            <span
                role="img"
                class="fa-regular fa-circle-info agpr-importRecipients-help"
                agprTooltip="Common.mailingLists.importDialog.helpMessage"
                [escape]="false"
            ></span>
        </div>
        <agpr-form-message *ngIf="fileError">
            {{ 'Common.mailingLists.importDialog.uploadError' | localize }}
        </agpr-form-message>
    </div>
    <div
        *ngIf="hasFile"
        class="agpr-importRecipients-content agpr-importRecipients-content--fileLoaded"
        [agprLoading]="loading"
    >
        <div class="agpr-selectAll">
            <agpr-checkbox
                [id]="selectAllCheckboxId"
                label="Common.mailingLists.importDialog.chooseRecipients"
                [binary]="true"
                hiddenLabel="selectAll"
                [(ngModel)]="selectAll"
                (ngModelChange)="toggleSelectAll()"
            ></agpr-checkbox>
        </div>
        <agpr-scroll-panel>
            <ul
                class="agpr-recipients"
                [attr.aria-label]="'Common.mailingLists.importDialog.list.ariaLabel' | localize"
            >
                <li
                    *ngFor="let recipient of recipients; let i = index"
                    class="agpr-recipient"
                    [class.agpr-recipient--selected]="selectedRecipients | includes:recipient"
                >
                    <agpr-checkbox
                        [id]="'importRecipientsDialog_recipient-' + i"
                        [value]="recipient"
                        [(ngModel)]="selectedRecipients"
                        (ngModelChange)="checkSelectAll()"
                    >
                        <div>
                            <div class="agpr-recipient-name">
                                {{ recipient.name }}
                            </div>
                            <div class="agpr-recipient-email">
                                {{ recipient.email }}
                            </div>
                        </div>
                    </agpr-checkbox>
                </li>
            </ul>
        </agpr-scroll-panel>
    </div>

    <ng-template #footerLeft>
        <agpr-button
            id="importRecipientsDialog.cancel"
            label="Core.button.cancel"
            [disabled]="loading"
            (click)="cancel()"
        >
        </agpr-button>
    </ng-template>
    <ng-template #footerRight>
        <agpr-button
            *ngIf="!hasFile"
            id="importRecipientsDialog.browse"
            label="Common.mailingLists.importDialog.browse"
            [style]="buttonTypes.primary"
            [disabled]="loading"
            (click)="browse()"
        >
        </agpr-button>
        <ng-container *ngIf="hasFile">
            <agpr-autocomplete
                #autocomplete
                id="importRecipientsDialog.mailingLists"
                [(ngModel)]="selectedMailingList"
                [dropdown]="true"
                [suggestions]="mailingLists$"
                [customOptions]="customOptions"
                label="Common.mailingLists.importDialog.mailingList.label"
                [placeholder]="'Common.mailingLists.importDialog.mailingList.placeholder' | localize"
                labelField="name"
                [clearOnBlur]="false"
            >
            </agpr-autocomplete>
            <agpr-button
                id="importRecipientsDialog.ok"
                label="Common.mailingLists.importDialog.createRecipients"
                [style]="buttonTypes.primary"
                [disabled]="loading || selectedRecipients.length < 1"
                (click)="ok()"
            >
            </agpr-button>
        </ng-container>
    </ng-template>
</agpr-dialog-container>
